import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction} from '@reduxjs/toolkit';

import { getLanguage } from '@/utils/utils';
import { getState } from './store';
export type Language = 'zh' | 'en'
export interface ICommomType {
  language: Language,
}

const initialState:ICommomType = {
  language: getLanguage(),
};
export const common = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLanguage: (state, {payload}: PayloadAction<ICommomType['language']> ) => {
      state.language = payload;
    },
  }
});

export const {
  setLanguage,
} = common.actions;
export const getLanguageFromRedux = ():Language => {
  const state = getState()
  return state.common.language
}
export default common.reducer;